import type { NurseResponse, NurseWithRelation } from "@vTypes/nurse-type.ts";

// 이건 무슨칼라..?
const colorArray = [
  "254, 14, 130",
  "14, 89, 198",
  "41, 171, 226",
  "247, 147, 30",
];

/** insertPreceptorData가 붙이는 UI 메타 (null = 프리셉터 그룹 없음) */
export type PreceptorUiAttachment =
  | null
  | {
      role: "preceptee" | "preceptor";
      group: { preceptor: string; preceptee: string[] };
      groupIndex: number;
      color: string;
      or: string[];
      ee: string[];
    };

export type WithPreceptorUi<T> = T & { preceptor: PreceptorUiAttachment };

type PreceptorLayoutNurse = Pick<
  NurseResponse,
  "nurse_id" | "preceptor_id" | "name"
>;

export const getPreceptorLabel = (nurse: NurseWithRelation): string => {
  if (nurse.preceptees.length > 0) return "프리셉터";
  if (nurse.preceptor) return nurse.preceptor.name;
  return "-";
};

export function generatePreceptorGroupIDs(
  list: readonly PreceptorLayoutNurse[]
) {
  const preceptorMap = new Map<string, string[]>();

  list.forEach((nurse) => {
    const preceptorID = nurse.preceptor_id;
    const nurseID = nurse.nurse_id;
    if (preceptorID) {
      if (!preceptorMap.has(preceptorID)) {
        preceptorMap.set(preceptorID, []);
      }
      preceptorMap.get(preceptorID)!.push(nurseID);
    }
  });

  return Array.from(preceptorMap.entries()).map(([preceptor, preceptee]) => ({
    preceptor,
    preceptee,
  }));
}

export function insertPreceptorData<T extends PreceptorLayoutNurse = NurseResponse>(
  fullNurseSchema: T[],
  preceptorGroup: { preceptor: string; preceptee: string[] }[]
): WithPreceptorUi<T>[] {
  return fullNurseSchema.map((nurse) => {
    const groupIndex = preceptorGroup.findIndex(
      (g) =>
        g.preceptor === nurse.nurse_id || g.preceptee.includes(nurse.nurse_id)
    );

    if (groupIndex === -1) {
      return { ...nurse, preceptor: null };
    }

    const group = preceptorGroup[groupIndex];
    const role = nurse.preceptor_id !== null ? "preceptee" : "preceptor";
    const color = colorArray[groupIndex] ?? "#ccc";

    const or = fullNurseSchema
      .filter((n) => n.nurse_id === group.preceptor)
      .map((n) => n.name);

    const ee = group.preceptee
      .map((eeId) => fullNurseSchema.find((n) => n.nurse_id === eeId)?.name)
      .filter(Boolean) as string[];

    return {
      ...nurse,
      preceptor: {
        role,
        group,
        groupIndex,
        color,
        or,
        ee,
      },
    };
  });
}
